import { MatchingType } from '../../types/EquipmentTypes';

export default {
  title: 'Hull Outfitting',
  items: [
    {
      title: 'Accommodation Ladders',
      hasMaker: false,
      hasType: false,
      makers: [],
      standardServices: [
        {
          title: 'Load Test',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Repair',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Anchors',
      hasMaker: false,
      hasType: false,
      makers: [],
      standardServices: [
        {
          title: 'Replacement',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Bow Thruster',
      hasMaker: true,
      hasType: true,
      makers: [
        'Kongsberg (Rolls Royce)',
        'Kawasaki',
        'Wartsila',
        'KTE Nakashima',
        'Brunvoll',
      ],
      standardServices: [
        {
          title: 'General Overhauling',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Motor Repairs',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Cargo Gear/HHC',
      hasMaker: true,
      hasType: true,
      makers: [
        'IHI',
        'TTS',
        'Oriental',
        'Tech Flower',
        'Ningbo Kairong',
        'Mitsubishi',
        'Manabe Zoki',
        'Kyoritsu Kikai',
        'Acta Cranes',
        'Jiangsu - Masada',
        'Kawasaki',
        'BLM Cranes',
        'Pusnes',
      ],
      standardServices: [
        {
          title: 'Sheaves Replacement',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Wire Replacement',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Hydraulic Hoses Replacement',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Hydraulic Repairs',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Load Test',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Bearing Replacement',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'HVAC',
      hasMaker: false,
      hasType: false,
      makers: [
        'Hi Air',
        'Flakt Woods',
        'Johnson Controls',
        'York',
        'Goodman Air Conditioning',
        'DMA',
        'Daikin',
        'Namirei Showa',
      ],
      standardServices: [],
      items: [
        {
          title: 'Main A/C Unit',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
        {
          title: 'ECR A/C Unit',
          hasMaker: true,
          hasType: true,
          standardServices: [
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
      ],
    },
    {
      title: 'Provision Cranes',
      hasMaker: true,
      hasType: true,
      makers: [
        'Macgregor',
        'Mansei',
        'Oriental',
        'TTS',
        'BLM Cranes',
        'Jiangsu - Masada',
        'IHI',
        'Haean',
        'Tsuji',
        'Sekigahara',
      ],
      standardServices: [
        {
          title: 'Wire Replacement',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Hydraulic Hoses Replacement',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Hydraulic Repairs',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Load Test',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Sheaves Replacement',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Bearing Replacement',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Provision Plant',
      hasMaker: true,
      hasType: true,
      makers: [
        'Hi Air',
        'Flakt Woods',
        'DMA',
        'Daikin',
        'York',
        'Namirei - Showa',
        'Ushio',
      ],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Rudder',
      hasMaker: false,
      hasType: false,
      standardServices: [
        {
          title: 'Bush Replacement',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Body Repair',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Winches',
      hasMaker: true,
      hasType: true,
      makers: [
        'TTS',
        'Kongsberg (Rolls Royce)',
        'Flutek',
        'Mitsubishi',
        'Eyde',
        'IHI',
        'Pusnes',
        'Manabe Zoki',
        'Macgregor',
        'Mirae',
        'Kawasaki',
        'Brohl',
        'Fukushima',
        'Aker Kvaener Pusnes',
      ],
      standardServices: [
        {
          title: 'Hydraulic System Inspection/Repairs',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Build-up',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Motor Replacement',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [
        {
          title: 'Mooring Ropes',
          hasMaker: false,
          hasType: true,
          standardServices: [
            {
              title: 'Mooring Ropes Inspection',
              matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
            },
            {
              title: 'Other',
              matching: [MatchingType.EQUIPMENT],
            },
          ],
        },
      ],
    },
    {
      title: 'Windlass',
      hasMaker: true,
      hasType: true,
      makers: [
        'TTS',
        'Kongsberg (Rolls Royce)',
        'Flutek',
        'Mitsubishi',
        'Eyde',
        'IHI',
        'Pusnes',
        'Manabe Zoki',
        'Macgregor',
        'Mirae',
        'Kawasaki',
        'Brohl',
        'Fukushima',
        'Aker Kvaener Pusnes',
      ],
      standardServices: [
        {
          title: 'Hydraulic System Inspection/Repairs',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Build-up',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Motor Replacement',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
  ],
};
